import styled from "styled-components";

export const DashboardContainer = styled.div`
  /* display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center; */
  position: relative;
  width: 100%;
  overflow-y: auto;
  padding: 40px 10px;
  -ms-overflow-style: none;
  scrollbar-width: none;
  @media (max-width: 1024px) {
    height: auto;
    margin-top: 50px;
    padding-bottom: 0;
    background: unset;
  }
`;

export const UploaderContainer = styled.div`
  width: 308px;
  height: 32px;
  background: #e9ebf8;
  border: 1px solid #e9ebf8;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 4px;
  direction: rtl;
  color: #5276a3;
  /* margin:0 auto; */

  & span {
    display: inline-flex;
    align-items: center;
    color: var(--text-400);
    font-size: 10px;
    font-weight: 400;
    margin: auto auto;
    justify-content: center;
    @media (max-width: 1024px) {
      justify-content: flex-start;
      margin: auto 0;
      /* &.disableTitle{
      color: var(--text-100);
     } */
    }
  }
  & label {
    color: #27548c;
    display: flex;
    justify-content: center;
    cursor: pointer;
    height: 24px;
    width: 88px;
    align-items: center;
    background: var(--bg-white);
    border: 1px solid var(--bg-gray);
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: var(--text-500);
    @media (max-width: 1024px) {
      color: var(--bg-disable);
      background-color: var(--primary-500);
      height: 100%;
      width: 107px;
      font-size: 16px;
      font-weight: 700;
    }
    &.disable {
      opacity: 0.5;
      &:hover {
        cursor: not-allowed;
      }
    }
    & input {
      color: #27548c;
    }
  }
  @media (max-width: 1200px) {
    width: 328px;
  }
  @media (max-width: 1024px) {
    flex-direction: row-reverse;
    width: calc(360px - 32px);
    margin: 24px auto 40px auto;
  }
`;

export const SelectOrRecordAudioContainer = styled.div`
  background: var(--bg-white);
  height: max-content;
  width: 100%;
  border: 1px solid #e9ebf8;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 16px;
  padding: 40px 60px;
  flex: 2;
  /* margin-top: 48px; */
  @media (max-width: 1500px) {
    /* margin-top: 300px; */
  }
  div.button-wrapper {
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    button:last-child {
      margin-left: 12px;
    }
    @media (max-width: 1024px) {
      flex-wrap: wrap;
      justify-content: center;
    }
  }

  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  @media (max-width: 1024px) {
    box-shadow: none;
    background: transparent;
    border: none;
    margin-top: 0;
    &:last-child {
      margin-bottom: 175px;
    }

    div.button-wrapper {
      padding: 0;
      justify-content: flex-start;
      button {
        width: 120px;
        font-size: 14px;
      }
      button:last-child {
        margin-left: 8px;
        display: inline-block;
      }
    }
    div.button-text button:first-child div {
      justify-content: space-between;
      align-items: baseline;
      width: 100%;
    }
    div.button-text button:first-child div span {
      margin: 0;
    }
    div.button-text button:first-child img {
      display: none;
    }
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  cursor: pointer;
  width: 245px;
  margin-left: auto;
  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const PlayAndUpload = styled.div`
  /* padding: 0.5rem 0; */
  display: flex;
  flex-direction: column;
  align-items: end;
  min-height: 120px;
  @media (max-width: 360px) {
    flex-direction: column;
  }
`;

export const FileInputContainer = styled.form`
  display: flex;
  align-items: center;
  width: 100%;
  direction: rtl;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 10px;
  @media (max-width: 1024px) {
    display: flex;
    flex-direction: column;
  }
`;
export const RecentFileContainer = styled.div`
  background: var(--bg-white);
  width: 100%;
  border: 1px solid var(--bg-gray);
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 16px;
  padding: 32px 60px;
  margin-top: 24px;
  flex: 1;
  /* margin-bottom: 30px; */
  h2 {
    font-size: 18px;
    font-weight: 700;
    direction: rtl;
    color: var(--text-500);
    margin-bottom: 24px;
  }
  @media (max-width: 1024px) {
    background-color: transparent;
    box-shadow: none;
    border: none;
    margin-top: 50px;
    padding-right: 16px;
    padding-left: 16px;
    margin-bottom: 140px;
  }
`;

export const TableRowCard = styled.div`
  display: flex;
  justify-content: space-between;
  background-color: #fbfbff;
  border: 1px solid #e7e8f3;
  min-height: 96px;
  padding: 18px 32px 18px 18px;
  align-items: center;
  display: flex;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  border-radius: 12px;
  font-size: 14px;
  font-weight: 700;
  direction: rtl;
  margin-bottom: 16px;
  @media (max-width: 1100px) {
    padding: 18px 18px;
  }
  @media (max-width: 1024px) {
    align-items: center;
    margin-left: auto;
    margin-right: auto;
  }
  &:last-child {
    margin-bottom: 0;
  }
  &:hover {
    cursor: pointer;
  }
  & > div:nth-child(2),
  div:nth-child(3) {
  }
  &.disable {
    opacity: 0.6;
    & > div:last-child:hover {
      text-decoration: none;
    }
    &:hover {
      cursor: not-allowed;
    }
  }
`;

export const RecentFilesTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
  color: var(--text-500);
  @media (max-width: 1024px) {
    margin-right: 20px;
  }
`;

export const RecentFilesCharacter = styled.div`
  font-size: 14px;
  font-weight: 500;
  color: var(--text-500);
  @media (max-width: 1024px) {
    display: none;
  }
`;
export const RecentFilesDownload = styled.div`
  display: flex;
  align-items: center;
  padding: 29px 5px;
  & > div {
    font-size: 16px;
    font-weight: 700;
    color: var(--primary-500);
    display: inline-block;
    margin-right: 9.25px;
    @media (max-width: 1200px) {
      font-size: 14px;
    }
    @media (max-width: 1400px) {
      margin-right: 5px;
    }
    & a {
      font-size: 16px;
      font-weight: 700;
      color: #6caeff;
      display: inline-block;
      margin-right: 9.25px;
      transition: 0.8s;
    }
  }
  @media (max-width: 1024px) {
    display: none;
  }
`;

export const Tbody = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  font-weight: 500;
  color: #2d3134;
`;

export const TextEditorContainer = styled.div`
  width: 100%;
  @media (max-width: 480px) {
    /* width: calc(360px - 32px); */
    margin: 0 auto;
  }
  &.disable {
    opacity: 0.5;
    &:hover {
      cursor: not-allowed;
    }
  }
`;

export const DownloadButtonContainer = styled.div`
  display: flex;
  color: #6caeff;
  font-size: 16px;
  font-weight: 700;
`;

export const ImgContainer = styled.div`
  margin-left: 5px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  & button {
    font-size: 16px;
    font-weight: 700;
    width: 150px;
    height: 40px;
    background-color: var(--bg-white);
  }
  & button:nth-of-type(1) {
    margin-right: 4px;
    background-color: #6caeff;
  }

  & p {
    color: #27548c;
    display: inline-block;
    direction: rtl;
  }
  & span {
  }
  @media (max-width: 768px) {
    flex-direction: column;
    & > div {
      margin-bottom: 20px;
    }
  }
  @media (max-width: 480px) {
    direction: ltr;
    & button {
      width: 120px;
    }
  }
`;
export const ButtonContainerr = styled.div`
  display: flex;
  direction: ltr;
  gap: 10px;
  @media (max-width: 360px) {
    direction: ltr;
  }
`;
export const RightContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 47%;

  @media (max-width: 1024px) {
    justify-content: flex-start;
    & svg {
      color: var(--text-500);
    }
  }
  @media (max-width: 480px) {
    width: 60%;
  }

  /* @media (max-width: 768px) {
    width: 20%;
  }
  @media (max-width: 480px) {
    width: 50%;
  } */
`;

export const FormRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  direction: rtl;
  flex-wrap: wrap;
  @media (max-width: 1024px) {
    flex-direction: row-reverse;
    width: 100%;
    gap: 16px;
    margin-bottom: 16px;
  }
  @media (max-width: 360px) {
    width: calc(360px - 16px);
  }
  & select {
    height: 42px;
    border-radius: 8px;
    width: 180px;
    padding: 8px;
    font-weight: 500;
    font-size: 14px;
    background-color: transparent;
    border: none;
    border: 1px solid #e9ebf8;
    color: #629ee8;
    @media (max-width: 1200px) {
      width: 154px;
    }

    &.disable {
      opacity: 0.5;
      &:hover {
        cursor: not-allowed;
      }
    }
    & option {
      @media (max-width: 1200px) {
        width: 130px;
      }
    }
  }
`;

export const TextEditorEditContainer = styled.div`
  margin-top: 16px;
  &.disable {
    opacity: 0.5;
    &:hover {
      cursor: not-allowed;
    }
  }
`;

export const TitleContainer = styled.div`
  direction: rtl;
  @media (max-width: 1024px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  & input {
    height: 32px;
    width: 308px;
    border-radius: 8px;
    outline: none;
    border: none;
    font-size: 14px;
    font-weight: 500;
    color: var(--text-500);
    border: 1px solid var(--bg-gray);
    padding: 8px;
    @media (max-width: 1024px) {
      width: 328px;
    }
    &::placeholder {
      color: var(--text-500);
      font-size: 14px;
      font-weight: 500;
    }
  }
  &.disable input {
    opacity: 0.5;
    &:hover {
      cursor: not-allowed;
    }
  }
`;

export const RecentFilesWave = styled.div`
  width: 50%;
  align-items: center;
  direction: ltr;
  & wave {
    overflow: hidden !important;
  }
  & .status {
    color: var(--text-500);
    font-size: 16px;
    font-weight: 700;
  }
  & .topContainer {
    /* background-color: transparent !important; */
    box-shadow: none;
    border-radius: 0;
    flex: 1;
    & .button {
      width: 48px;
      height: 48px;
      /* background: linear-gradient(
        180deg,
        #4d77ac 3.65%,
        rgba(98, 158, 232, 0.8) 49.48%,
        #4d77ac 92.71%
      );
     
      border: 2px solid transparent; */
      background: linear-gradient(
        180deg,
        #4d77ac 3.65%,
        rgba(98, 158, 232, 0.8) 49.48%,
        #4d77ac 92.71%
      );
      border-radius: 50%;
      &:hover {
        background: white;
        border: 1px solid #4d77ac;
      }
      & svg {
        width: 48px;
        height: 48px;
        /* border: 2px solid green;
        border-radius: 50%; */
        color: white !important;
        fill: white !important;
        &:hover {
          color: #4d77ac !important;
          fill: #4d77ac !important;
        }
      }
    }
  }
  & > div {
    @media (max-width: 1024px) {
      & .button {
        width: 32px;
        height: 32px;
      }
    }
  }
  /* @media (max-width: 1100px) {
    & > div > div {
      background-color: red;
      flex-direction: column;
    }
  } */

  @media (max-width: 1024px) {
    width: 65%;
    & .controller {
      display: none;
    }
  }
  @media (max-width: 768px) {
    width: 80%;
  }
  @media (max-width: 480px) {
    width: 40%;
  }
`;

export const SampleContainer = styled.div`
  & div {
    /* width: 200px; */
    direction: ltr;
    & > wave {
      overflow: hidden hidden !important;
    }
    @media (max-width: 1024px) {
      /* background: #fbfbff;
      box-shadow: 0px 5.4px 11.7px rgba(108, 136, 170, 0.1);
      border-radius: 8px; */
      & > wave {
        height: 32px !important;
        overflow: hidden hidden !important;
      }
    }
  }
  & div:nth-of-type(4),
  & div:nth-of-type(3) {
    display: none;
  }
  & .controller {
    display: none !important;
  }
  @media (max-width: 1024px) {
    flex: 1;
  }
`;

export const DropDownContainer = styled.div`
  border: 1px solid var(--bg-gray);
  border-radius: 8px;
  width: auto;
  min-width: 100px;
  min-height: max-content;
  position: relative;
  cursor: pointer;
  transition: 0.5;
  & .hidden {
    display: none;
  }
  &:hover {
    border: 1px solid var(--primary-500);
  }
  @media (max-width: 1024px) {
    flex: 1;
  }
  @media (max-width: 360px) {
    width: 328px;
    /* margin-bottom: 20px; */
  }
  & > div {
    display: flex;
    align-items: center;
  }
  & > div span {
    display: block;
    color: #27548c;
    padding: 8px;
    font-size: 14px;
    font-weight: 500;
  }
  & > div svg {
    color: #629ee8;
    position: absolute;
    left: 5%;
    &.open {
      transform: rotate(180deg);
    }
  }
`;
export const OptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  color: var(--text-500);
  position: absolute;
  border: 1px solid var(--bg-gray);
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
  right: 0;
  left: 0;
  top: 32px;
  z-index: 100;
  background-color: #fff;
  font-size: 14px;
  font-weight: 500;
  font-family: "IRANYekanMobileFN";
  & > div {
    width: 100%;
    padding: 8px;
    &:last-child {
      // border-top: 1px solid #e9ebf8;
      border-bottom-right-radius: 8px;
      border-bottom-left-radius: 8px;
    }
    &:hover {
      background-color: #d1e6ff;
    }
  }
`;

export const DisableWave = styled.div`
  direction: ltr;
  opacity: 0.5;
  width: 130px;
  pointer-events: none;
  cursor: not-allowed;
  height: auto;
  & div {
    & > wave {
      overflow: hidden hidden !important;
    }
  }
  @media (max-width: 1024px) {
    & div {
      & > wave {
        height: 32px !important;
      }
    }
  }
  &:hover {
    cursor: not-allowed;
  }
  & wave,
  svg {
    &:hover {
      cursor: not-allowed;
      pointer-events: none;
    }
  }
  & .controller {
    background-color: red;
    display: none !important;
  }
  @media (max-width: 1024px) {
    flex: 1;
  }
`;
export const ModalContainer = styled.div`
  position: absolute;
  background-color: rgba(0, 0, 0, 0.05);
  top: 0;
  bottom: 0;
  z-index: 1100;
  left: 0;
  right: 0;
`;
export const RecentFileModal = styled.ul`
  width: 100%;
  position: fixed;
  height: 380px;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 36px 20px;
  z-index: 100;
  direction: rtl;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: var(--bg-white);
  display: flex;
  flex-direction: column;
  & .download {
    display: flex;
    align-items: center;
    & img {
      margin-left: 10px;
    }
  }
  & > div {
    padding: 30px 0;
    font-size: 20px;
    font-weight: 500;
    color: var(--text-500);
    border-bottom: 1px solid #f4f7fc;
    @media (max-width: 480px) {
      font-size: 16px;
    }
    @media (max-width: 360px) {
      font-size: 14px;
    }
  }
`;
